export const INVOICE_LIST_REQUEST_STARTED = 'INVOICE_LIST_REQUEST_STARTED';
export const INVOICE_LIST_REQUEST_SUCCESS =  'INVOICE_LIST_REQUEST_SUCCESS';
export const INVOICE_LIST_REQUEST_FAILED = 'INVOICE_LIST_REQUEST_FAILED'
export const FILTER_INVOICES = 'FILTER_INVOICES'
export const INVOICE_LIST_CLOSE_NOTIFICATION = 'INVOICE_LIST_CLOSE_NOTIFICATION'
export const INVOICE_LIST_FORM_VALUE_CHANGED = 'INVOICE_LIST_FORM_VALUE_CHANGED'

export const INVOICE_SETTING_REQUEST_STARTED = 'INVOICE_SETTING_REQUEST_STARTED';
export const INVOICE_SETTING_REQUEST_SUCCESS =  'INVOICE_SETTING_REQUEST_SUCCESS';
export const INVOICE_SETTING_REQUEST_FAILED = 'INVOICE_SETTING_REQUEST_FAILED'

export const INVOICE_DETAIL_REQUEST_STARTED = 'INVOICE_DETAIL_REQUEST_STARTED';
export const INVOICE_DETAIL_REQUEST_SUCCESS =  'INVOICE_DETAIL_REQUEST_SUCCESS';
export const INVOICE_DETAIL_REQUEST_FAILED = 'INVOICE_DETAIL_REQUEST_FAILED'
